// File: src/styles/GlobalStyles.js
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  /* Reset & Base Styles */
  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    font-size: 16px;
  }

  body {
    font-family: 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    background-color: #FDF7F2;
    color: #1a1a1a;
    line-height: 1.75;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    text-decoration: none;
    color: inherit;
    transition: color 0.2s ease-in-out;
  }

  a:hover {
    color: #4f46e5; /* Indigo 600 */
  }

  ul, ol {
    list-style: none;
  }

  img {
    max-width: 100%;
    display: block;
  }

  button {
    font-family: inherit;
    font-size: 1rem;
    border: none;
    cursor: pointer;
    background-color: transparent;
    transition: background-color 0.2s ease-in-out;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'DM Serif Display', Georgia, serif;
    font-weight: 400;
    line-height: 1.2;
    color: #111827;
  }

  h1 {
    font-size: 2.75rem;
  }

  h2 {
    font-size: 2.25rem;
  }

  h3 {
    font-size: 1.75rem;
  }

  h4 {
    font-size: 1.5rem;
  }

  p {
    margin-bottom: 1rem;
    color: #374151; /* Gray 700 */
  }

  ::selection {
    background: #c4a25d33;
    color: #111111;
  }

  /* Skip-to-content link for keyboard users */
  .skip-link {
    position: absolute;
    top: -100%;
    left: 1rem;
    z-index: 9999;
    background: #C4A25D;
    color: #111111;
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 0.875rem;
    padding: 0.6rem 1.25rem;
    border-radius: 0 0 0.375rem 0.375rem;
    text-decoration: none;
    transition: top 0.1s;

    &:focus {
      top: 0;
    }
  }

  /* Global focus-visible — keyboard nav only */
  :focus-visible {
    outline: 2px solid #C4A25D;
    outline-offset: 3px;
    border-radius: 2px;
  }

  /* Remove focus outline for mouse users */
  :focus:not(:focus-visible) {
    outline: none;
  }
/* Utilities */
  .btn {
    padding: 0.75rem 1.5rem;
    background-color: #4f46e5;
    color: white;
    border-radius: 0.375rem;
    font-weight: 600;
    text-decoration: none;
    display: inline-block;
    transition: background 0.2s ease, transform 0.2s ease;
    box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  }

  .btn:hover {
    background-color: #4338ca;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0,0,0,0.1);
  }

  .btn-outline {
    background-color: transparent;
    border: 2px solid #4f46e5;
    color: #4f46e5;
  }

  .btn-outline:hover {
    background-color: #eef2ff;
  }

  .section-heading {
    font-size: 1.75rem;
    color: #1f2937;
    margin-bottom: 1rem;
    position: relative;
    padding-bottom: 0.5rem;
  }

  .section-heading::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    height: 4px;
    width: 50px;
    background: #4f46e5;
    border-radius: 2px;
  }

  .section {
    padding: 80px 20px;
  }

  .section-alt {
    background-color: #f9fafb;
  }

  .flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .grid-2 {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 2rem;
  }

  .timeline-dot {
    position: relative;
    padding-left: 1.75rem;
  }

  .timeline-dot::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0.5rem;
    width: 12px;
    height: 12px;
    background: #4f46e5;
    border-radius: 50%;
  }

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}

.grid-3 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
}
  

`;

export default GlobalStyles;
